/* eslint-disable */
import React, { PureComponent } from 'react';
import { Document, Page,pdfjs } from 'react-pdf';
// import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { Spin } from 'antd';
import styles from './File.less';
// if(pdfjs){
//   pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
// }

class File extends PureComponent {
  state = {
    numPages: 0,
    pageWidth: 800,
  };
  onDocumentLoadSuccess = (PDF) => {
    const { numPages } = PDF;
    if (this.props.onLoadSuccess) {
      this.props.onLoadSuccess(PDF);
    }
    this.setState({ numPages });
  }
  render() {
    const { numPages } = this.state;
    const protocal = this.props.url.slice(4, 5);
    const pdfUrl = protocal === 's' ? this.props.url : `${this.props.url.slice(0, 4)}s${this.props.url.slice(4)}`;
    return (
      <div className={styles.view}>
        <div className={styles.pageContainer}>
          <Document
            file={pdfUrl}
            onLoadSuccess={this.onDocumentLoadSuccess}
            onLoadError={() => {
            }}
            loading={<div className="pdfLoadding"><Spin /><p style={{ marginLeft: '8px' }}>正在加载pdf文件，请耐心等待</p></div>}
          >
            {

              new Array(numPages).fill(0).map((v, index) => <Page key={index} pageNumber={index + 1} width={this.props.width || 600} />)
            }
          </Document>
        </div>
      </div>
    );
  }
  }

export default File;
